import * as types from '../actions/ActionTypes';

const initialState = {
  loading: false,
  postagesList: [],
  postageAccountsList: [],
  postageRecord: [],
  postageAccountRecord: null,
  redirectToList: false,
  validation_error: "",
  showUpdateForm: false,
  showPostageAccountUpdateForm: false,
  showViewPage: false,
};

const PostageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.POSTAGE_REQUEST:
      return { ...state, loading: true, redirectToList: false };
    case types.POSTAGE_SUCCESS:
      return { ...state, loading: false, postagesList: action.postagesList };
    case types.POSTAGE_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        postageRecord: action.record,
        showUpdateForm: action.actionType === 'update',
        showViewPage: action.actionType === 'view',
      };
    case types.POSTAGE_ACCOUNTS_REQUEST:
      return {
        ...state,
        loading: true,
        redirectToList: false,
      };
    case types.POSTAGE_ACCOUNTS_SUCCESS:
      return {
        ...state,
        loading: false,
        postageAccountsList: action.postageAccountsList,
      };
    case types.POSTAGE_ACCOUNT_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        postageAccountRecord: action.record,
        showPostageAccountUpdateForm: action.actionType === 'update',
      };
    case types.POSTAGE_VALIDATION_ERROR:
      return { ...state, loading: false, validation_error: action.validation_error };
    case types.POSTAGE_ACCOUNT_VALIDATION_ERROR:
      return { ...state, loading: false, validation_error: action.validation_error };
    case types.POSTAGE_REDIRECT_TO_LIST:
      return {
        ...state,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
        postageRecord: null,
      };
    case types.POSTAGE_ACCOUNT_REDIRECT_TO_LIST:
      return {
        ...state,
        redirectToList: true,
        showPostageAccountUpdateForm: false,
        postageAccountRecord: null,
      };
    default:
      return state;
  }
};

export default PostageReducer;
